import React from "react";

import { useEffect, useState } from "react";
import { useSpring, animated } from "react-spring";
import { BrowserRouter, Route, Routes} from 'react-router-dom';
import Home from "./pages/home";
import About from "./pages/about";
import Skill from "./pages/skills";
import Projects from "./pages/project";
import Contact from "./pages/contact";
import Services from "./pages/services";
import Navbar from "./components/navbar";
import Socials from "./components/social/social";
import Footer from "./components/footer/footer";
import Hire from "./pages/Hireme/hire";


function App() {

  return (
    <BrowserRouter>
    <div className="App  h-full w-full">
      <div className=" bg-yellow-950 h-full w-full">
        

        {/* navbar */}
        <Navbar />
        <div className="fixed top-[50%] right-0 z-40">
          <Socials />
        </div>



        {/* main page content */}
        <Routes>
         
          <Route index path="/" element={<Home/>} />
          <Route path="/about" element={<About />} />
          <Route path="/skills" element={<Skill />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/hireMe" element={<Hire/>} />

        </Routes>
      </div>
      <Footer />
    </div>
    </BrowserRouter>
  );
}

export default App;
